import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface VoucherValidationRequest {
  code: string;
  totalAmount: number;
}

export interface VoucherValidationResponse {
  valid: boolean;
  voucher?: {
    id: number;
    code: string;
    discountType: 'percentage' | 'fixed';
    discountValue: number;
    description?: string;
    minimumOrderAmount?: number;
  };
  discountAmount?: number;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  private apiUrl = `${environment.baseUrl}/vouchers`;

  constructor(private http: HttpClient) {}

  private getHttpOptions() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      })
    };
  }

  validateVoucher(request: VoucherValidationRequest): Observable<VoucherValidationResponse> {
    return this.http.post<any>(`${this.apiUrl}/validate`, request, this.getHttpOptions())
      .pipe(
        map((response: any) => response.data[0]) // Extract the actual data from the wrapped response
      );
  }

  applyVoucher(code: string, totalAmount: number): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/apply`, { code, totalAmount }, this.getHttpOptions())
      .pipe(
        map((response: any) => response.data[0]) // Extract the actual data from the wrapped response
      );
  }
}
